import { useContext } from "react";
import { useMatch } from "react-router";
import { ReportContext } from "../context";
/** Resolved absolute pathname of the mounted report root, with no trailing
 * slash, for building `` `${root}/${subpath}` `` link targets.
 *
 * The report mounts under a dynamic base (portal and standalone mount
 * differently), so every in-report link is expressed relative to this root
 * rather than to the current page. A root mount (`/`) returns `""`, keeping
 * those joins valid single-slash paths; a bare-root navigation target is
 * therefore `root || "/"`. */
const useReportRootPath = () => {
    var _a;
    const { routerRootPath } = useContext(ReportContext);
    const match = useMatch({ path: routerRootPath, end: false });
    return ((_a = match === null || match === void 0 ? void 0 : match.pathnameBase) !== null && _a !== void 0 ? _a : "").replace(/\/$/, "");
};
export default useReportRootPath;
//# sourceMappingURL=useReportRootPath.js.map